import React, { useState } from "react";
import { Rect } from "react-konva";

const Rectangle = ({
  shapeProps,
  x,
  y,
  width,
  height,
  fill,
  opacity,
  id,
  seekTime,
  seek,
  startTime,
  endTime,
  currentTime,
}) => {
  const [hover, setHover] = useState(false);

  return (
    <Rect
      name={"rect"}
      {...shapeProps}
      x={x}
      y={y}
      width={width}
      height={height}
      fill={fill}
      opacity={
        hover || (startTime <= currentTime && currentTime < endTime)
          ? opacity
          : 0
      }
      id={id}
      onMouseOver={() => {
        setHover(true);
      }}
      onMouseOut={() => {
        setHover(false);
      }}
      onClick={() => {
        seek(seekTime);
      }}
    />
  );
};

export default Rectangle;
